import RequestingDappInfo from './RequestingDappInfo'

export default RequestingDappInfo
